import {createSlice} from '@reduxjs/toolkit';
import {googleLogin, googleRegister, microsoftLogin, microsoftRegister, registerUser, userLogin} from '../actions/authActions';

// initialize userToken from local storage
const user = localStorage.getItem ('userDetails')
  ? JSON.parse(localStorage.getItem ('userDetails'))
  : null;
const language = localStorage.getItem("language") ? localStorage.getItem("language") : "en"

  // const userInfo= localStorage.getItem ('userInfo')
  // ? localStorage.getItem ('userInfo')
  // : null;

const initialState = {
  loading: false,
  userInfo: user, // for user object
  error: null,
  success: false, // for monitoring the registration process.
  language:language,
  // UI prefs
  userGuideEnabled: (user && typeof user.show_user_guide !== 'undefined') ? !!user.show_user_guide : true,
  userGuideOpen: false,
};

const authSlice = createSlice ({
  name: 'auth',
  initialState,
  reducers: {
    logout: state => {
      // ...logout reducer
      state.userInfo = null;
      localStorage.removeItem ('userDetails');
    },
    setCredentials: (state, {payload}) => {
      state.userInfo = payload;
    },
    setSuccess: (state, {payload}) => {
      state.success = payload;
    },
    setError:(state,{payload})=>{
      state.error = payload;
    },
    setLanguage:(state,{payload})=>{
      state.language=payload;
      localStorage.setItem("language",payload);
    },
    setUserGuideEnabled:(state,{payload})=>{
      state.userGuideEnabled = !!payload;
      // Also mirror into userInfo for consistency when persisted later
      if(state.userInfo){
        state.userInfo.show_user_guide = !!payload;
        localStorage.setItem('userDetails', JSON.stringify(state.userInfo));
      }
    },
    setUserGuideOpen:(state,{payload})=>{
      state.userGuideOpen = !!payload;
    }
  },
  extraReducers: builder => {
    //login user reducer
    builder.addCase (userLogin.pending, (state, {payload}) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase (userLogin.fulfilled, (state, {payload}) => {
      // console.log(payload);
      state.loading = false;
      state.success = true; // login successful
      state.userInfo = payload;
    });

    builder.addCase (userLogin.rejected, (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    });

    //register user reducer
    builder.addCase (registerUser.pending, (state, {payload}) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase (registerUser.fulfilled, (state, {payload}) => {
      state.loading = false;
      state.success = true; // registration successful
    });

    builder.addCase (registerUser.rejected, (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    });

      //google login user reducer
      builder.addCase (googleLogin.pending, (state, {payload}) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase (googleLogin.fulfilled, (state, {payload}) => {
        // console.log(payload);
        state.loading = false;
        state.success = true; // login successful
        state.userInfo = payload;
      });
  
      builder.addCase (googleLogin.rejected, (state, {payload}) => {
        state.loading = false;
        state.error = payload;
      });


    //google register user reducer
    builder.addCase (googleRegister.pending, (state, {payload}) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase (googleRegister.fulfilled, (state, {payload}) => {
      state.loading = false;
      state.success = true; // registration successful
    });

    builder.addCase (googleRegister.rejected, (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    });


         //microsoft login user reducer
         builder.addCase (microsoftLogin.pending, (state, {payload}) => {
          state.loading = true;
          state.error = null;
        });
        builder.addCase (microsoftLogin.fulfilled, (state, {payload}) => {
          // console.log(payload);
          state.loading = false;
          state.success = true; // login successful
          state.userInfo = payload;
        });
    
        builder.addCase (microsoftLogin.rejected, (state, {payload}) => {
          state.loading = false;
          state.error = payload;
        });
  
  
      //microsoft register user reducer
      builder.addCase (microsoftRegister.pending, (state, {payload}) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase (microsoftRegister.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.success = true; // registration successful
      });
  
      builder.addCase (microsoftRegister.rejected, (state, {payload}) => {
        state.loading = false;
        state.error = payload;
      });

  },
});
export const {logout, setCredentials, setSuccess,setError,setLanguage} = authSlice.actions;
export const {setUserGuideEnabled, setUserGuideOpen} = authSlice.actions;
export default authSlice.reducer;
